const FirewallConfigHome = () => import(/* webpackChunkName: "group-pabx-config" */ '../_views/FirewallConfigHome')

import { permissionsPabx } from '../../../../../utils/permissionsPabx'

export default [
  {
    path: 'firewall',
    component: FirewallConfigHome,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Firewall',
  },
]
